import React, { Component, Fragment } from 'react'
import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import inject from 'helpers/inject'
import formField from 'helpers/formField'

import Card, { CardContent, CardActions } from 'material-ui/Card'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import FormInput from 'components/forms/FormInput'
import AsyncButton from 'components/AsyncButton'

import RouterService from 'services/router'
import ApiService from 'services/api'

import recoverPassword from 'tasks/recoverPassword'

import withAppStore from 'decorators/withAppStore'

import styles from 'styles/pages/auth/recovery'

@withStyles(styles)
@withAppStore
@observer
export default class extends Component {

  router = inject(RouterService)
  api = inject(ApiService)

  @observable isSent = false
  @observable isSending = false
  @observable error

  email = formField({
    value: '',
    label: 'Адрес электронной почты',
    type: 'email',
    name: 'email',
    validations: {
      presence: true,
      email: true
    }
  })

  componentWillMount() {
    this.appStore.pageTitle = 'Восстановление пароля'
  }

  render() {
    const { classes } = this.props

    return (
      <Card elevation={1} className={ classes.card } >
        <CardContent className={ classes.content } >
          { this.isSent ? (
            <Typography color='primary' type='subheading' >
              Новый пароль отправлен на указанный адрес
            </Typography>
          ) : (
            <Fragment>
              <Typography paragraph color='secondary' align='left' >
                Введите адрес электронной почты, который использовался при регистрации аккаунта.
                На этот адрес будет отправлено письмо с новым паролем.
              </Typography>
              <FormInput
                field={ this.email }
                TextFieldProps={{
                  fullWidth: true,
                  disabled: this.isSending
                }}
              />
            </Fragment>
          )}
          { this.error &&
            <Typography color='error' align='left' >
              { this.error }
            </Typography>
          }
        </CardContent>
        <CardActions>
          <Button fullWidth onClick={ this.handleBack } >
            Назад
          </Button>
          { !this.isSent &&
            <AsyncButton
              action={ this.handleRecover }
              label='Восстановить'
              processingLabel=''
              successLabel='Успешно!'
              ButtonProps={{
                fullWidth: true,
                raised: true,
                color: 'primary'
              }}
            />
          }
        </CardActions>
      </Card>
    )
  }

  @action.bound
  handleBack() {
    this.router.transitionTo('/auth?login')
  }

  @action.bound
  async handleRecover() {
    this.error = null
    this.email.validate()
    if (this.email.hasErrors) throw new Error()
    try {
      const email = this.email.value
      await recoverPassword.perform({ email })
      this.isSent = true
    } catch (error) {
      this.error = 'Не удалось отправить новый пароль. Пожалуйста, проверьте адрес электронной почты'
      throw error
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/recovery.js